<script>
  export default {
    name: 'maker-material-prices',
    data: () => ({
      tableData: [
        { item: `4" x 6" glossy`, price: `$0.75/sheet` },
        { item: `5" x 7" glossy`, price: `$2.00/sheet` },
        { item: `8" x 10" glossy`, price: `$3.25/sheet` },
        { item: `8" x 10" matte`, price: `$3.00/sheet` },
        { item: `11" x 17" glossy`, price: `$5.00/ sheet` },
        { item: `17" x 22" glossy`, price: `$8.00/sheet` },
        { item: `3D Print`, price: `$1.00/hour` },
        { item: `15 oz Infusible Ink Mug`, price: `$5.00/mug` },
        { item: `Specialty Mug`, price: `Varying` },
        { item: `Removable Vinyl`, price: `$2.00/sheet` },
        { item: `Permanent Vinyl`, price: `$2.00/sheet` },
        { item: `Heat Transfer Iron-on Vinyl`, price: `$2.00/sheet` },
        { item: `Cardstock Paper`, price: `$1.00/sheet` },
        { item: `Large T-Shirt`, price: `$12.00/shirt` },
        { item: `Medium T-Shirt`, price: `$11.00/shirt` },
        { item: `Small T-Shirt`, price: `$10.00/shirt` },
        { item: `Specialty Item`, price: `Varying` }
      ],
      tableHeaders: [
        {
          text: 'Size / Type',
          align: 'start',
          sortable: true,
          value: 'item'
        },
        { text: 'Cost / Unit', sortable: true, value: 'price' }
      ]
    })
  }
</script>

<template>
  <v-card width="100%" class="mt-16">
    <v-app-bar color="primary" dark>
      <v-toolbar-title class="text-h5 font-weight-bold">Materials & Pricing</v-toolbar-title>
    </v-app-bar>
    <v-card-text class="card-text primary--text font-weight-bold px-4 px-sm-12">
      <p class="text-body-1 primary--text mt-5">
        Patrons can bring their own compatible, staff approved materials when using the Maker Lab.
        <br />
        The library also offers materials required for all of the available equipment.
        <br />
        Please refer to the pricing table below for current costs per unit.
      </p>
      <v-sheet width="100%" max-width="500" class="mx-auto my-8">
        <v-data-table dense :headers="tableHeaders" hide-default-footer :items="tableData" :items-per-page="50" item-key="material"></v-data-table>
      </v-sheet>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>
